<template>
  <div class="variant-fields">
    <div class="variant-fields__row">
      <SplitNameFormPart
        :first-name-placeholder="$t('placeholder.firstName')"
        :last-name-placeholder="$t('placeholder.lastName')"
        v-on="$listeners"
      />
    </div>

    <AddressFormGroup init-postal-with-store-key="postal" v-on="$listeners" />

    <PhoneField
      :label="$t('field.phone.label')"
      :placeholder="$t('placeholder.phone')"
      v-on="$listeners"
    />

    <EmailField
      :label="$t('field.email.label')"
      :placeholder="$t('placeholder.email')"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import EmailField from 'chimera/all/components/form/fields/email/EmailField'
import PhoneField from 'chimera/all/components/form/fields/phone/PhoneField'
import SplitNameFormPart from 'chimera/all/components/form/parts/SplitNameFormPart.vue'
import AddressFormGroup from '~/components/form/part/address/AddressFormGroup.PD-10913'

export default {
  name: 'ContactInformationFormPart',

  components: {
    SplitNameFormPart,
    EmailField,
    PhoneField,
    AddressFormGroup,
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "placeholder": {
      "firstName": "Jan",
      "lastName": "de Vries",
      "phone": "06 12345678",
      "email": "naam@voorbeeld.nl"
    }
  }
}
</i18n>
